/**
 * <CldImg> · drop-in <img> wrapper that transparently applies
 * `f_auto,q_auto` (+ optional `w_<n>`, `dpr_auto`) to any Cloudinary
 * URL. Falls through unchanged for non-Cloudinary URLs.
 *
 * Also sets sensible perf defaults:
 *   · loading="lazy"      (below-the-fold safe)
 *   · decoding="async"    (never blocks the paint)
 *
 * Pass `eager` when the image is above-the-fold (hero, first card).
 */
import React from "react";
import { cldOpt, cldSrcSet } from "@/lib/cloudinary";

export default function CldImg({
  src,
  w,
  q,
  dpr,
  srcSetWidths,
  sizes,
  eager = false,
  loading,
  decoding,
  ...rest
}) {
  const optimized = cldOpt(src, { w, q, dpr });
  const srcSet = srcSetWidths ? cldSrcSet(src, srcSetWidths) : undefined;
  return (
    <img
      src={optimized}
      srcSet={srcSet}
      sizes={sizes}
      loading={loading || (eager ? "eager" : "lazy")}
      decoding={decoding || "async"}
      {...rest}
    />
  );
}
